import React from 'react';
import { useUser } from '../../contexts/UserContext';
import SignInWithTwitchButton from '../../components/SignInWithTwitchButton';
import { LscLogo } from '../components/LscLogo';
import LoadingState from '../components/LoadingState';

interface UseLscAuthGateOptions {
  returnTo: string;
  title?: string;
  message?: string;
}

export function useLscAuthGate({
  returnTo,
  title = 'Sign in required',
  message = 'Sign in with Twitch to access your league workspaces.',
}: UseLscAuthGateOptions) {
  const { user, loading, authError } = useUser();
  return { user, loading, isAuthenticated: !!user, authError, returnTo, title, message };
}

export function LscAuthGate({
  returnTo,
  title,
  message,
  children,
}: UseLscAuthGateOptions & { children: React.ReactNode }) {
  const { loading, isAuthenticated, authError } = useLscAuthGate({ returnTo, title, message });

  if (loading) {
    return <LoadingState message="Checking sign-in status..." />;
  }

  if (!isAuthenticated) {
    return (
      <div className="max-w-lg mx-auto">
        <div className="card text-center">
          <LscLogo variant="hero" className="mx-auto mb-6" />
          <h1 className="text-2xl font-bold text-white mb-3">{title}</h1>
          <p className="text-secondary-300 mb-6">{message}</p>
          {authError && (
            <p className="mb-4 text-sm text-red-400" role="alert">
              {authError}
            </p>
          )}
          <SignInWithTwitchButton returnTo={returnTo} />
        </div>
      </div>
    );
  }

  return <>{children}</>;
}
